import ProfileLayout from "../../layouts/ProfileLayout";
import axiosInstance from "../../apiHandles/axiosInstance";
import React, { useContext, useEffect, useState } from "react";
import { UserProgressContext } from "../../context/UserProgressContext";
import { changeInfo, checkOldPassword } from "../../apiHandles/user_progress";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { deletAccount } from "../../apiHandles/user_progress"
import { changeSoundOn, changeDarkMode, changeGreekOn } from "../../apiHandles/user_progress"
import "../../assets/css/argon-dashboard-react.css"
import { useDarkMode } from "context/DarkModeProvider";
import { useLanguage } from "context/LanguageProvider";
import "../../assets/css/argon-dashboard-react.css";
import "../../assets/css/Profile.css"
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { motion, AnimatePresence } from "framer-motion";

const FIELD_ICONS = {
  username: "fa-solid fa-user",
  email: "fa-solid fa-envelope",
  password: "fa-solid fa-lock",
};

const Profile = () => {
  // Profile modal states
  const [showModal, setShowModal] = useState(false);
  const [variable, setVariable] = useState("");
  const [newValue, setNewValue] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [correctMessage, setCorrectMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [email, setEmail] = useState("");
  const { level } = useContext(UserProgressContext);
  const [, setIsLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const navigate = useNavigate();

  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem("language");
    return stored || "greek";
  });

  const [soundEnabled, setSoundEnabled] = useState(null);
  const [soundLoading, setSoundLoading] = useState(true);

  const handleLanguageChange = (selectedLanguage) => {
    setLanguage(selectedLanguage);
    localStorage.setItem("language", selectedLanguage);
  };

  const toggleSound = async () => {
    try {
      const newValue = !soundEnabled;
      setSoundEnabled(newValue);
      localStorage.setItem("soundEnabled", JSON.stringify(newValue));
      await changeSoundOn();
    } catch (error) {
      console.error("Error updating sound setting:", error);
      setSoundEnabled(!newValue);
    }
  };

  const handleDeleteAccount = async () => {
    const deleted = await deletAccount();
    if (deleted) {
      navigate("/login");
    }
    setShowDeleteModal(false);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    setErrorMsg("");
    setCorrectMessage("");
    setShowOldPassword(false);
    setShowNewPassword(false);
    setOldPassword("");
    setNewValue("");
    setSaving(false);
  };

  const handleChange = (field) => {
    setVariable(field);
    setNewValue("");
    setOldPassword("");
    setErrorMsg("");
    setCorrectMessage("");
    setSaving(false);
    setShowOldPassword(false);
    setShowNewPassword(false);
    setShowModal(true);
  };

  const handleSave = async () => {
    setSaving(true);
    setErrorMsg("");

    if (variable === "password") {
      if (!oldPassword.trim()) {
        setErrorMsg(selLanguage ? "Παρακαλώ εισάγετε τον τρέχοντα κωδικό σας." : "Please enter your current password.");
        setSaving(false); return;
      }
      if (!newValue.trim()) {
        setErrorMsg(selLanguage ? "Παρακαλώ εισάγετε τον νέο κωδικό σας." : "Please enter your new password.");
        setSaving(false); return;
      }

      const accepted = await checkOldPassword(oldPassword);
      if (accepted) {
        changeInfo("password", newValue);
        setCorrectMessage(selLanguage ? "Ο κωδικός άλλαξε επιτυχώς." : "Password changed successfully.");
        setErrorMsg("");
        setTimeout(() => {
          setShowModal(false);
          setCorrectMessage("");
        }, 1800);
      } else {
        setErrorMsg(selLanguage ? "Ο τρέχων κωδικός δεν είναι σωστός. Παρακαλώ δοκιμάστε ξανά." : 'The current password is incorrect. Please try again.');
      }
    } else {
      const fieldName = variable === "username" ? "username" : "email";
      if (!newValue.trim()) {
        setErrorMsg(selLanguage ? `Παρακαλώ εισάγετε το νέο ${fieldName}.` : `Please enter the new ${fieldName}.`);
        setSaving(false); return;
      }

      if (variable === "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(newValue)) {
          setErrorMsg(selLanguage ? "Παρακαλώ εισάγετε ένα έγκυρο email." : "Please enter a valid e-mail");
          setSaving(false); return;
        }
      }

      const result = await changeInfo(variable, newValue);
      if (result !== false && result !== null) {
        localStorage.setItem(variable, newValue);

        if (variable === "email") {
          setEmail(newValue);
        }

        setCorrectMessage(selLanguage ? "Τα στοιχεία σας άλλαξαν επιτυχώς." : "Your changes have been saved successfully");
        setShowModal(true);
        setErrorMsg("");
        setTimeout(() => {
          setShowModal(false);
          setCorrectMessage("");
        }, 1800);

      } else {
        setErrorMsg(selLanguage ? `Το ${fieldName} υπάρχει ήδη. Δοκιμάστε κάποιο άλλο.` : `The ${fieldName} already exists. Please try something else`);
      }
    }
    setSaving(false);
  };

  const { darkMode, toggleDarkMode, isLoading: darkModeLoading } = useDarkMode();

  useEffect(() => {
    if (errorMsg) {
      const timer = setTimeout(() => {
        setErrorMsg("");
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [errorMsg]);

  useEffect(() => {
    axiosInstance
      .get("user/userBasicInfo/")
      .then((res) => {
        setEmail(res.data.email);
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  }, []);

  const fieldLabel = variable === "username"
    ? "Username"
    : variable === "email"
      ? "Email"
      : selLanguage ? "Κωδικός" : "Password";

  const inputClass = `floating-input${darkMode ? "" : " light-input"}`;

  return (
    <ProfileLayout>

      <div className="general-background" style={{
        background: darkMode ? "#0f172a" : "#f4f3ef"
      }}>

        <Card className="profileCard" style={{
          background: darkMode
            ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
            : '#fff',
          border: darkMode ? 'none' : '2px solid #e0f2fe'
        }}>
          <CardHeader style={{ background: "none", border: "none" }}>
            <div style={{ textAlign: "center" }}>
              <div className="profileAvatar"
                style={{
                  background: darkMode
                    ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                    : 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'
                }}
              >
                <i
                  className="fa-solid fa-user"
                  style={{
                    fontSize: "30px",
                    color: "#ffffff"
                  }}
                ></i>
              </div>
              <p
                style={{
                  color: darkMode ? "#f1f5f9" : "#1e293b",
                  fontFamily: 'Montserrat',
                  fontWeight: 600,
                  fontSize: "30px ",
                  margin: 0,
                  transition: "color 0.3s"
                }}
              >
                {selLanguage ? "Προφίλ" : "Profile"}
              </p>
            </div>
          </CardHeader>

          <CardBody className="firstBody">
            {/* Username */}
            <div className="InfoContainer"
              style={{
                background: darkMode
                  ? 'rgba(51, 65, 85, 0.5)'
                  : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",

                }}
              >
                <div
                  style={{
                    fontSize: "clamp(14px, 2.5vw, 18px)",
                    color: darkMode ? "#f1f5f9" : "#1e293b",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8vw",

                  }}
                >
                  <i
                    className="fa-solid fa-user"
                    style={{
                      color: darkMode ? "#60a5fa" : "#3b82f6",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                    }}
                  ></i>
                  <span style={{ color: darkMode ? "var(--commonProfileGrey)" : "#64748b" }}>
                    Username:{" "}
                    <span style={{ color: darkMode ? "#ffffff" : "#1e293b" }}>
                      {localStorage.getItem("username") || "N/A"}
                    </span>
                  </span>

                </div>

                <Button
                  className="gradient-button"
                  onClick={() => handleChange("username")}
                >
                  {selLanguage ? "Αλλαγή" : "Change"}
                </Button>
              </div>
            </div>

            {/* Email */}
            <div
              className="InfoContainer"
              style={{
                background: darkMode
                  ? 'rgba(51, 65, 85, 0.5)'
                  : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(14px, 2.5vw, 18px)",
                    color: darkMode ? "#f1f5f9" : "#1e293b",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.7vw"
                  }}
                >
                  <i
                    className="fa-solid fa-envelope"
                    style={{
                      color: darkMode ? "#3b82f6" : "#2563eb",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                    }}
                  ></i>
                  <span style={{ color: darkMode ? "var(--commonProfileGrey)" : "#64748b" }}>
                    Email:{" "}
                    <span style={{
                      color: darkMode ? "#f1f5f9" : "#1e293b",
                      fontWeight: 600,
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                    }}>{email}</span>
                  </span>

                </div>

                <Button
                  className="gradient-button"
                  onClick={() => handleChange("email")}
                >
                  {selLanguage ? "Αλλαγή" : "Change"}
                </Button>
              </div>
            </div>

            {/* Password */}
            <div
              className="InfoContainer"
              style={{
                background: darkMode
                  ? 'rgba(51, 65, 85, 0.5)'
                  : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(14px, 2.5vw, 18px)",
                    color: darkMode ? "#f1f5f9" : "#1e293b",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8vw"
                  }}
                >
                  <i
                    className="fa-solid fa-lock"
                    style={{
                      color: darkMode ? "#3b82f6" : "#2563eb",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                    }}
                  ></i>
                  <span style={{ color: darkMode ? "var(--commonProfileGrey)" : "#64748b", marginRight: "0.5vw" }}>
                    {selLanguage ? "Κωδικός" : "Password"}:{" "}
                    <span style={{ color: darkMode ? "#f1f5f9" : "#1e293b", fontWeight: 600 }}>••••••••</span>
                  </span>

                </div>

                <Button
                  className="gradient-button "
                  onClick={() => handleChange("password")}
                >
                  {selLanguage ? "Αλλαγή" : "Change"}
                </Button>
              </div>
            </div>
          </CardBody>
        </Card>


        {/* Settings Column */}

        <Card
          className="profileCard"
          style={{
            background: darkMode
              ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'
              : '#fff ',
            border: darkMode ? 'none' : '2px solid #e0f2fe'
          }}
        >
          <CardHeader style={{ background: "none", border: "none" }}>
            <div style={{ textAlign: "center", }}>
              <div
                className="profileAvatar"
                style={{
                  background: darkMode
                    ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
                    : 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)'
                }}
              >
                <i
                  className="fa-solid fa-gear"
                  style={{
                    fontSize: "30px",
                    color: "#ffffff",
                    animation: "spin 8s linear infinite"
                  }}
                ></i>
              </div>
              <h3
                style={{
                  color: darkMode ? "#f1f5f9" : "#1e293b",
                  fontFamily: "Montserrat",
                  fontWeight: 600,
                  fontSize: "30px",
                  letterSpacing: "-0.025em",
                  transition: "color 0.3s"
                }}
              >
                {selLanguage ? "Ρυθμίσεις" : "Settings"}
              </h3>

            </div>
          </CardHeader>

          <CardBody style={{
            display: "flex", flexDirection: "column",
            alignItems: "center",
            padding: "1rem"
          }}>
            {/* Language Setting */}
            <div
              className="InfoContainer"
              style={{
                background: darkMode
                  ? 'rgba(51, 65, 85, 0.5)'
                  : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "1vw"
              }}>
                <div
                  style={{
                    fontSize: "clamp(14px, 2.5vw, 18px)",
                    color: darkMode ? "var(--commonProfileGrey)" : "#1e293b",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8vw",
                    whiteSpace: "nowrap"
                  }}
                >
                  <i
                    className="fa-solid fa-language"
                    style={{
                      color: darkMode ? "#06b6d4" : "#0891b2",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                    }}
                  ></i>
                  {selLanguage ? "Γλώσσα" : "Language"}
                </div>

                <div style={{ display: "flex", gap: "8px", flexShrink: 0 }}>
                  <button
                    className="languageButton"
                    style={{
                      padding: "8px 14px",
                      minWidth: "85px",
                      whiteSpace: "nowrap",
                      borderRadius: "15px",
                      border: "none",
                      fontSize: "17px",
                      fontWeight: 600,
                      cursor: "pointer",
                      // boxShadow: language === "greek" ? "0 4px 12px rgba(45, 110, 214, 0.3)" : "none",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      background: language === "greek"
                        ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                        : darkMode
                          ? "rgba(51, 65, 85, 0.8)"
                          : "rgba(241, 245, 249, 0.8)",
                      color: language === "greek"
                        ? "#ffffff"
                        : darkMode ? "#e2e8f0" : "#475569",
                      transform: "translateY(0)"
                    }}
                    onMouseEnter={(e) => { if (language !== "greek") e.target.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={(e) => { if (language !== "greek") e.target.style.transform = "translateY(0)"; }}
                    onClick={async () => {
                      handleLanguageChange("greek");
                      if (!selLanguage) await changeGreekOn();
                      window.location.reload();
                    }}
                  >
                    Ελληνικά
                  </button>

                  <button
                    className="languageButton"
                    style={{
                      padding: "0.8vw 1.4vw",
                      borderRadius: "15px",
                      border: "none",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                      // boxShadow: language === "english" ? "0 4px 12px rgba(45, 110, 214, 0.3)" : "none",
                      fontWeight: 600,
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      background: language === "english"
                        ? "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
                        : darkMode
                          ? "rgba(51, 65, 85, 0.8)"
                          : "rgba(241, 245, 249, 0.8)",
                      color: language === "english"
                        ? "#ffffff"
                        : darkMode ? "#e2e8f0" : "#475569",
                      transform: "translateY(0)"
                    }}
                    onMouseEnter={(e) => { if (language !== "english") e.target.style.transform = "translateY(-2px)"; }}
                    onMouseLeave={(e) => { if (language !== "english") e.target.style.transform = "translateY(0)"; }}
                    onClick={async () => {
                      handleLanguageChange("english");
                      if (selLanguage) await changeGreekOn();
                      window.location.reload();
                    }}
                  >
                    English
                  </button>
                </div>
              </div>
            </div>

            {/* Dark/Light Mode Setting */}
            <div
              className="InfoContainer"
              style={{
                background: darkMode
                  ? 'rgba(51, 65, 85, 0.5)'
                  : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(14px, 2.5vw, 18px)",
                    color: darkMode ? "var(--commonProfileGrey)" : "#1e293b",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8vw"
                  }}
                >
                  <i
                    className={darkMode ? "fa-solid fa-moon" : "fa-solid fa-sun"}
                    style={{
                      color: darkMode ? "#fbbf24" : "#f59e0b",
                      fontSize: "clamp(14px, 2.5vw, 18px)",
                      transition: "all 0.3s ease"
                    }}
                  ></i>
                  {selLanguage ? darkMode ? "Σκοτεινή λειτουργία" : "Φωτεινή λειτουργία" : darkMode ? "Dark Mode" : "Light Mode"}
                </div>

                {darkModeLoading ? (
                  <div style={{ position: "relative", width: "6.4vw", height: "3.2vw", borderRadius: "30px", background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)", opacity: 0.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ width: "1.4vw", height: "1.4vw", border: "2px solid #ffffff", borderTop: "2px solid transparent", borderRadius: "20px", animation: "spin 1s linear infinite" }} />
                  </div>
                ) : (
                  <button
                    onClick={toggleDarkMode}
                    style={{
                      position: "relative", width: "64px", height: "32px", minWidth: "64px", borderRadius: "30px", border: "none", cursor: "pointer",
                      background: darkMode ? "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" : "linear-gradient(135deg, #fef3c7 0%, #fbbf24 100%)",
                      transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                      // boxShadow: darkMode ? "0 8px 32px rgba(15, 23, 42, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.05)" : "0 8px 32px rgba(251, 191, 36, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                      overflow: "hidden"
                    }}
                  >
                    <div
                      className={`toggleButtonDarkMode ${darkMode ? "dark" : "light"}`}
                      style={{
                        background: darkMode ? "linear-gradient(135deg, #475569 0%, #334155 100%)" : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        boxShadow: darkMode ? "0 4px 16px rgba(0, 0, 0, 0.3)" : "0 4px 16px rgba(0, 0, 0, 0.15)",
                        transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                        transform: "translateY(-50%)"
                      }}
                    >
                      <i
                        className={darkMode ? "fa-solid fa-moon" : "fa-solid fa-sun"}
                        style={{ fontSize: "clamp(12px, 2vw, 16px)", color: darkMode ? "#fbbf24" : "#f59e0b", transition: "all 0.3s ease" }}
                      />
                    </div>
                  </button>
                )}
              </div>
            </div>

            {/* Delete Account Section */}
            <div
              className="InfoContainer"
              style={{
                background: darkMode ? 'rgba(51, 65, 85, 0.5)' : 'rgba(248, 250, 252, 0.8)',
                border: darkMode ? '1px solid rgba(148, 163, 184, 0.1)' : '1px solid #e0f2fe'
              }}
            >
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1vw"
              }}>
                <div style={{ fontSize: "clamp(14px, 2.5vw, 18px)", color: darkMode ? "var(--commonProfileGrey)" : "#1e293b", fontWeight: 600, display: "flex", alignItems: "center", gap: "0.8vw" }}>
                  <i className="fa-solid fa-trash" style={{ color: "#ef4444", fontSize: "clamp(14px, 2.5vw, 18px)" }}></i>
                  {selLanguage ? "Διαγραφή λογαριασμού" : "Delete Account"}
                </div>
                <Button
                  className="delete-button"
                  onClick={() => setShowDeleteModal(true)}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#fff" }}
                  style={{ background: "linear-gradient(135deg, #b81e1eff 0%, #7c0505ff 100%)", borderRadius: "15px" }}
                >
                  {selLanguage ? "Διαγραφή" : "Delete"}
                </Button>
              </div>
            </div>

          </CardBody>

          <style jsx>{`
            @keyframes twinkle { 0%, 100% { opacity: 0.3; transform: scale(1); } 50% { opacity: 1; transform: scale(1.2); } }
            @keyframes float { 0%, 100% { transform: translateY(0px); } 33% { transform: translateY(-2px); } 66% { transform: translateY(1px); } }
            @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          `}</style>
        </Card>
      </div>

      <Modal isOpen={showModal} toggle={toggleModal} centered className="modern-modal">
        <div className={`modal-glass-card${darkMode ? "" : " light"}`}>

          {/* Header */}
          <div className="modal-modern-header">
            <div className="modal-header-left">
              <div className="modal-icon-wrap">
                <i className={FIELD_ICONS[variable] || "fa-solid fa-pen"}></i>
              </div>
              <div>
                <p className={`modal-title-text${darkMode ? "" : " light"}`}>
                  {selLanguage ? "Αλλαγή " : "Change "}{fieldLabel}
                </p>
                <p className="modal-subtitle-text">
                  {selLanguage ? "Εισάγετε τα νέα σας στοιχεία παρακάτω" : "Enter your new details below"}
                </p>
              </div>
            </div>
            <button className={`modal-close-modern${darkMode ? "" : " light"}`} onClick={toggleModal}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          {/* Body */}
          <div className="modal-modern-body">

            {correctMessage && (
              <div className="modal-alert success">
                <i className="fa-solid fa-circle-check"></i>
                {correctMessage}
              </div>
            )}
            {errorMsg && (
              <div className="modal-alert error">
                <i className="fa-solid fa-circle-exclamation"></i>
                {errorMsg}
              </div>
            )}

            <Form>
              {variable === "password" ? (
                <>
                  <div className="floating-input-group">
                    <input
                      className={inputClass}
                      type={showOldPassword ? "text" : "password"}
                      placeholder=" "
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      autoComplete="current-password"
                    />
                    <label className="floating-label">
                      {selLanguage ? "Τρέχων Κωδικός" : "Current Password"}
                    </label>
                    <button type="button" className="input-eye-btn" onClick={() => setShowOldPassword(!showOldPassword)}>
                      <i className={`fa-solid ${showOldPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                    </button>
                  </div>

                  <div className="modal-fields-divider"></div>

                  <div className="floating-input-group">
                    <input
                      className={inputClass}
                      type={showNewPassword ? "text" : "password"}
                      placeholder=" "
                      value={newValue}
                      onChange={(e) => setNewValue(e.target.value)}
                      autoComplete="new-password"
                    />
                    <label className="floating-label">
                      {selLanguage ? "Νέος Κωδικός" : "New Password"}
                    </label>
                    <button type="button" className="input-eye-btn" onClick={() => setShowNewPassword(!showNewPassword)}>
                      <i className={`fa-solid ${showNewPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                    </button>
                  </div>
                </>
              ) : (
                <div className="floating-input-group">
                  <input
                    className={inputClass}
                    type={variable === "email" ? "email" : "text"}
                    placeholder=" "
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    autoComplete="off"
                  />
                  <label className="floating-label">
                    {selLanguage
                      ? `Νέο ${variable === "username" ? "Username" : "Email"}`
                      : `New ${variable === "username" ? "Username" : "Email"}`}
                  </label>
                </div>
              )}

              <button
                type="button"
                className="modal-save-btn"
                onClick={handleSave}
                disabled={saving}
              >
                {saving
                  ? (selLanguage ? "Αποθήκευση..." : "Saving...")
                  : (selLanguage ? "Αποθήκευση" : "Save Changes")}
              </button>
            </Form>
          </div>
        </div>
      </Modal>


      <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)} centered className="modern-modal">
        <div className={`modal-glass-card${darkMode ? "" : " light"}`}>

          <div className="modal-modern-header">
            <div className="modal-header-left">
              <div className="modal-icon-wrap" style={{ background: "linear-gradient(135deg, rgba(239,68,68,0.2), rgba(185,28,28,0.2))", border: "1px solid rgba(239,68,68,0.25)" }}>
                <i className="fa-solid fa-trash" style={{ color: "#f87171" }}></i>
              </div>
              <div>
                <p className={`modal-title-text${darkMode ? "" : " light"}`} style={{ color: "#f87171" }}>
                  {selLanguage ? "Επιβεβαίωση Διαγραφής" : "Confirm Deletion"}
                </p>
                <p className="modal-subtitle-text">
                  {selLanguage ? "Η ενέργεια αυτή είναι μόνιμη" : "This action is permanent"}
                </p>
              </div>
            </div>
            <button className={`modal-close-modern${darkMode ? "" : " light"}`} onClick={() => setShowDeleteModal(false)}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="modal-modern-body">
            <p style={{ color: darkMode ? "#cbd5e1" : "#475569", fontSize: "15px", lineHeight: "1.7", margin: "0 0 22px" }}>
              {selLanguage
                ? <><span>Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Αυτή η ενέργεια είναι </span><strong style={{ color: darkMode ? "#fca5a5" : "#dc2626" }}>μόνιμη</strong><span> και δεν μπορεί να αναιρεθεί. Όλα τα δεδομένα σας θα χαθούν.</span></>
                : <><span>Are you sure you want to delete your account? This action is </span><strong style={{ color: darkMode ? "#fca5a5" : "#dc2626" }}>permanent</strong><span> and cannot be undone. All your data will be lost forever.</span></>
              }
            </p>
            <div className="modal-action-row">
              <button
                className={`modal-cancel-btn${darkMode ? "" : " light"}`}
                onClick={() => setShowDeleteModal(false)}
              >
                {selLanguage ? "Ακύρωση" : "Cancel"}
              </button>
              <button className="modal-delete-confirm-btn" onClick={handleDeleteAccount}>
                {selLanguage ? "Διαγραφή" : "Delete Account"}
              </button>
            </div>
          </div>
        </div>
      </Modal>


      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @media (max-width: 992px) {
          .row { margin: 0 !important; max-width: 100% !important; }
          .col-md-6 { padding: 0 10px !important; margin-bottom: 1rem !important; }
        }
        @media (max-width: 768px) {
          .row { margin: 0 !important; }
          .col-md-6 { padding: 0 15px !important; margin-bottom: 1rem !important; }
        }
        @media (min-width: 1200px) {
          .row { max-width: 1400px !important; }
        }
      `}</style>
    </ProfileLayout>
  );
};

export default Profile;